import { Co2MaterialSettingType, DefaultRoles, FeatureManagementType, ModelScopeSettingType } from "@api/apiClient";
import { useAppSettings } from "@api/appSettings";
import MainLayout from "@components/Layouts/MainLayout";
import SettingsLayout from "@components/Layouts/SettingsLayout";
import ProjectAnalysisPage from "@features/analysis/components/ProjectAnalysisPage/ProjectAnalysisPage";
import LoginPage from "@features/auth/components/LoginPage/LoginPage";
import LogoutPage from "@features/auth/components/LogoutPage/LogoutPage";
import TermsAndConditionsPage from "@features/auth/components/TermsAndConditionsPage/TermsAndConditionsPage";
import ProjectsDashboardPage from "@features/dashboard/components/DashboardPage/DashboardPage";
import ProjectPage from "@features/project/components/ProjectPage/ProjectPage";
import AdminsPage from "@features/settings/components/AdminPage/AdminsPage";
import ApplicationLogsPage from "@features/settings/components/ApplicationLogsPage/ApplicationLogsPage";
import AppSettingsPage from "@features/settings/components/AppSettingsPage/AppSettingsPage";
import AutoMappingPage from "@features/settings/components/AutoMappingPage/AutoMappingPage";
import CadModelCategoryFilterPage from "@features/settings/components/CadModelCategoryFilter/CadModelCategoryFilterPage";
import Co2MaterialTypeByCategoryPage from "@features/settings/components/Co2MaterialTypeByCategoryPage/Co2MaterialTypeByCategoryPage";
import DesignAutomationPage from "@features/settings/components/DesignAutomationPage/DesignAutomationPage";
import DocumentsPage from "@features/settings/components/DocumentsPage/DocumentsPage";
import MaterialsPage from "@features/settings/components/MaterialsPage/MaterialsPage";
import ModelScopesPage from "@features/settings/components/ModelScopesPage/ModelScopesPage";
import NonModelledElementsPage from "@features/settings/components/NonModelledElementsPage/NonModelledElementsPage";
import PermissionsPage from "@features/settings/components/PermissionsPage/PermissionsPage";
import ProfilePage from "@features/settings/components/ProfilePage/ProfilePage";
import RebarEstimationPage from "@features/settings/components/RebarEstimationPage/RebarEstimationPage";
import RebarMaterialsPage from "@features/settings/components/MetaDataPage/MetaDataDetailsPage";
import RoleMappingPage from "@features/settings/components/RoleMappingPage/RoleMappingPage";
import RolesPage from "@features/settings/components/RolesPage/RolesPage";
import AccRolesPage from "@features/settings/components/AccRolesPage/AccRolesPage";
import UnmappedCadMaterialPage from "@features/settings/components/UnMappedCadMaterialPage/UnMappedCadMaterialPage";
import UserDetails from "@features/settings/components/UsersPage/UserDetails";
import UsersPage from "@features/settings/components/UsersPage/UsersPage";
import useAppStore from "@hooks/useAppStore";
import useUserPermissionStore from "@hooks/useUserPermissionStore";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

const MainRoutes = observer(() => {
  console.log("MainRoutes render");
  const appSettings = useAppSettings();
  const appStore = useAppStore();
  const upStore = useUserPermissionStore();

  useEffect(() => {
    return () => {
      console.log("MainRoutes unmount");
    };
  }, []);

  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<LoginPage />} />
        <Route path="/terms" element={<TermsAndConditionsPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/projects/:id/analysis" element={<ProjectAnalysisPage />} />
        <Route path="/projects/:id" element={<ProjectPage />} />
        <Route path="/projects" element={<ProjectsDashboardPage />} />
      </Route>

      <Route element={<SettingsLayout />}>
        <Route path="/settings" element={upStore.userPermission?.roles.includes(DefaultRoles.Admin) ? <AppSettingsPage /> : <ProjectsDashboardPage />}>
          {appSettings.data?.features?.includes(FeatureManagementType.RebarEstimation) && (
            <Route path="rebar-estimation" element={<RebarEstimationPage originScreen="Admin"  mode={appSettings.data?.profileLevelRebarSettings && appSettings.data?.profileLevelRebarSettings==true ? Co2MaterialSettingType.Profile:Co2MaterialSettingType.Global} />} />

          )}
          <Route path="non-modelled-elements" element={<NonModelledElementsPage />} />
          {/* TODO: To add appSettings check to add this feature */}
          <Route path="meta-data-management" element={<RebarMaterialsPage />} />
          <Route path="documents" element={<DocumentsPage />} />
          {appStore.hasFeature(FeatureManagementType.ModelScopes) && (
            <Route path="model-scopes" element={<ModelScopesPage mode={ModelScopeSettingType.Global} />} />
          )}
          <Route path="materials" element={<MaterialsPage />} />
          <Route path="application-logs" element={<ApplicationLogsPage />} />
          <Route path="unmapped-cad-materials" element={<UnmappedCadMaterialPage />} />
          <Route path="co2-material-type-by-category" element={<Co2MaterialTypeByCategoryPage />} />
          <Route path="auto-mapping" element={<AutoMappingPage />} />
          <Route path="design-automation" element={<DesignAutomationPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetails />} />
          <Route path="admin-users" element={<AdminsPage />} />
          <Route path="permissions" element={<PermissionsPage />} />
          <Route path="roles" element={<RolesPage />} />
          <Route path="acc-roles" element={<AccRolesPage />} />
          <Route path="role-mapping" element={<RoleMappingPage />} />
          <Route path="profiles" element={<ProfilePage />} />
          {appStore.hasFeature(FeatureManagementType.DACategoryFilter) && <Route path="cad-model-category-filter" element={<CadModelCategoryFilterPage />} />}
        </Route>
      </Route>
    </Routes>
  );
});

export default MainRoutes;
